import styles from "./AdminLayout.module.scss";
import bell from "../../assets/images/user-admin-panel/header/notification.svg";
import { useEffect, useRef, useState } from "react";
import userIcon from "../../assets/images/layouts/user.svg";
import Sidebar from "../../components/pages/admin-panels/sidebar/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { fetchUser } from "../../redux/Slices/userProfile";
import { AppDispatch, RootState } from "../../redux/store";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import i from "../../assets/images/pages/home/tariff-calculator/i.svg";
import ReferalModal from "../../components/pages/admin-panels/referal-accounts/referal-modal/ReferalModal";
import LogoutModal from "../../components/shared/logout-modal/LogoutModal";
import { setInfoModal } from "../../redux/Slices/infoModal";
import menuIcon from "../../assets/images/layouts/Menu Icon.svg";
import userIcon2 from "../../assets/images/layouts/userion.svg";
import LanguageSelect from "../../components/shared/languages-select/LanguagesSelect";
import map from "../../assets/images/layouts/navigation-icons/MapPinLine.svg";
import box from "../../assets/images/layouts/navigation-icons/Box.svg";
import card from "../../assets/images/layouts/navigation-icons/Cardholder.svg";
import filePlus from "../../assets/images/layouts/navigation-icons/FilePlus.svg";
import shoppingCart from "../../assets/images/layouts/navigation-icons/ShoppingCart.svg";
import truck from "../../assets/images/layouts/navigation-icons/Truck.svg";
import mailbox from "../../assets/images/layouts/navigation-icons/Mailbox.svg";
import check from "../../assets/images/layouts/navigation-icons/CheckCircle.svg";
import promocode from "../../assets/images/layouts/navigation-icons/CodeBlock.svg";
import attorney from "../../assets/images/layouts/navigation-icons/attorney-fee-svgrepo-com.svg";
import Spinner from "../../components/shared/spinner/Spinner";
import barIcon from "../../assets/images/layouts/edit-3-svgrepo-com (1).svg";
import barIcon2 from "../../assets/images/layouts/edit-3-svgrepo-com.svg";
import Wolt from "../../assets/images/layouts/navigation-icons/wolt.svg";
import { setLanguage } from "../../redux/Slices/languageSlice";
const AdminLayout = () => {
  const [pageTitle, setPageTitle] = useState<string>("");
  const [showInfo, setShowInfo] = useState(false);
  const dispatch = useDispatch<AppDispatch>();
  const { userInfo } = useSelector((state: RootState) => state.userProfile);
  const referalUser = useSelector((state: RootState) => state.referal.userName);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [logoutConfrim, setLogoutConfrim] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef<HTMLDivElement>(null);
  const language = useSelector((state: RootState) => state.language.language);
  // const {  loading: siteLoading } = useSite();

  const { loading: siteLoading, data } = useSelector(
    (state: RootState) => state.translationData
  );

  const user_navigations = [
    {
      name: data?.auth_left_sidebar_foreign_addresses,
      title: data?.auth_left_sidebar_foreign_addresses,
      path: "my-foriegn-locations",
      logo: map,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_parcels,
      title: data?.auth_left_sidebar_parcels,
      path: "my-packages",
      logo: box,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_balance,
      title: data?.auth_left_sidebar_balance,
      path: "my-balance",
      logo: card,
      search: false,
      info: false,
    },
     {
      name: data?.auth_left_sidebar_yp_order,
      title: data?.auth_left_sidebar_yp_order,
      path: "ypOrder",
      logo: mailbox,
      search: false,
      info: false,
    },
    // {
    //   name: data?.special_order || "Sifariş et",
    //   title: data?.special_order || "Sifariş et",
    //   path: "special-order",
    //   logo: shoppingCart,
    //   search: false,
    //   info: false,
    // },
    {
      name: data?.auth_left_sidebar_courier_order,
      title: data?.auth_left_sidebar_courier_order,
      path: "courier",
      logo: truck,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_wolt,
      title: data?.auth_left_sidebar_wolt,
      path: "wolt",
      logo: Wolt,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_azerpost_order,
      title: data?.auth_left_sidebar_azerpost_order,
      path: "mail",
      logo: mailbox,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_referral_accounts,
      title: data?.auth_left_sidebar_referral_accounts,
      // path: "referal-accounts",
      path: "lorem",
      logo: filePlus,
      search: false,
      info: false,
    },

    {
      name: data?.auth_left_sidebar_amazon_otp,
      title: data?.auth_left_sidebar_amazon_otp,
      path: "otp-code",
      logo: check,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_trendyol_otp,
      title: data?.auth_left_sidebar_trendyol_otp,
      path: "trendyol-otp",
      logo: check,
    },

    {
      name: data?.auth_left_sidebar_promo_code,
      title: data?.auth_left_sidebar_promo_code,
      path: "promocode",
      logo: promocode,
      search: false,
      info: false,
    },
    {
      name: data?.auth_left_sidebar_attorney,
      title: data?.auth_left_sidebar_attorney,
      path: "attorney",
      logo: attorney,
      search: false,
      info: false,
    },
    {
      name: data?.auth_common_notifications,
      title: data?.auth_common_notifications,
      path: "notifications",
    },
    {
      name: data?.service_debts_title || "Xidmət borcları",
      title: data?.service_debts_title || "Xidmət borcları",
      path: "service-debts",
      logo: card,
      search: false,
      info: false,
    },
  ];


  useEffect(() => {
    if (!userInfo) {
      dispatch(fetchUser());
    }
  }, [dispatch, userInfo]);
  const location = useLocation();
  const formattedPath = location.pathname
    .replace("/account", "")
    .replace(/^\/+/, "");

  useEffect(() => {
    const href = location.pathname;

    const currentNav = user_navigations.find(
      (nav) => nav.path === formattedPath
    );

    if (href.includes("special-order")) {
      setPageTitle(data?.special_order || "Sifariş et");
    } else if (href.includes("referal_accounts")) {
      setPageTitle(data?.auth_left_sidebar_referral_accounts || "");
    } else if (href.includes("newreferal")) {
      setPageTitle(data?.auth_referal_create_account || "");
    } else if (href.includes("referal-packages")) {
      setPageTitle(`${referalUser}`);
    } else if (href.includes("my-account")) {
      setPageTitle(data?.auth_common_my_account || "");
    } else {
      setPageTitle(currentNav?.title || "");
    }
    setShowInfo(currentNav?.info ?? false);
  }, [location.pathname, formattedPath, referalUser, user_navigations]);

  const handleModalClose = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target as Node)
      ) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);
  useEffect(() => {
    if (siteLoading || !data) return;

    const currentNav = user_navigations.find(
      (nav) => nav.path === formattedPath
    );
    setPageTitle(currentNav?.title || "");
  }, [data, siteLoading, formattedPath]);

  if (siteLoading) return <Spinner size="large" />;

  function toLocaleUpperCaseTR(str: string) {
    return str?.toLocaleUpperCase("tr-TR");
  }

  return (
    <div
      id={styles.admin_layout}
      className={sidebarOpen ? styles.sidebar_open : ""}
    >
      {sidebarOpen && (
        <div
          className={`${styles.overlay} ${sidebarOpen ? styles.active : ""}`}
          onClick={() => setSidebarOpen(false)}
        />
      )}
      <div ref={sidebarRef}>
        <Sidebar
          setShowModal={setShowModal}
          setLogoutConfrim={setLogoutConfrim}
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />
      </div>
      <div className={styles.main_content}>
        <header className={styles.header}>
          <div
            className={styles.toggle_icon}
            onClick={() => setSidebarOpen(true)}
          >
            <img src={menuIcon} alt="m" />
          </div>
          {showInfo ? (
            <div className={styles.title_info}>
              <h1 className={styles.page_title}>{pageTitle}</h1>
              {/* <div
                className={styles.info}
                onClick={() => dispatch(setInfoModal(true))}
              >
                <img src={i} alt="i" />
              </div> */}
            </div>
          ) : (
            <h1 className={styles.page_title}>
              {toLocaleUpperCaseTR(pageTitle)}
            </h1>
          )}

          <div className={styles.header_end}>
            <LanguageSelect
            // value={language}
            // onChange={(lang) => setLanguage(lang)}
            />
            <button
              style={{
                borderColor:
                  userInfo?.read_notification_count !== 0 ? "#97BEA5" : "",
              }}
              className={styles.note_button}
              onClick={() => navigate("notifications")}
            >
              <div className={styles.img}>
                <img src={bell} alt="bell" />
                {userInfo?.read_notification_count !== 0 && (
                  <div className={styles.notify_dot}></div>
                )}
              </div>
            </button>
            <button
              className={styles.user_btn}
              onClick={() => navigate("my-account")}
            >
              <div className={styles.user_name}>
                {userInfo?.name} {userInfo?.surname}
              </div>
              <div className={styles.user_icon}>
                <img src={userIcon} alt="user" />
              </div>
              <div className={styles.barIcon}>
                <img src={barIcon} alt="" />
              </div>
            </button>
            <div
              className={styles.user_mob_icon}
              onClick={() => navigate("my-account")}
            >
              <img src={userIcon2} alt="" />
            </div>
            <div className={styles.barIcon2}>
              <img src={barIcon2} alt="" />
              {/* <img src={barIcon2} alt="" /> */}
            </div>
          </div>
        </header>
        <main className={styles.page_content}>
          <Outlet />
        </main>
      </div>
      <ReferalModal visible={showModal} onClose={handleModalClose} />

      <LogoutModal
        logoutConfrim={logoutConfrim}
        setLogoutConfrim={setLogoutConfrim}
      />
    </div>
  );
};
export default AdminLayout;
